module.exports = __webpack_public_path__ + "img/aussermittige_einzellast.538e7d69.jpg";